<button
    type="button"
    class="play-button"
    [class.play-button--hovered]="hovered()"
    [disabled]="disabled()"
    [attr.tabindex]="focusable() ? null : -1"
    [attr.aria-hidden]="focusable() ? null : 'true'"
    [attr.aria-label]="focusable() ? ariaLabel() : null">
    <svg class="play-button__icon" width="37" height="42" viewBox="0 0 37 42" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M35.4742 18.3439C37.5086 19.5244 37.5086 22.4756 35.4742 23.6561L4.57732 41.5845C2.54295 42.765 -1.11936e-06 41.2894 -1.01616e-06 38.9285L5.51192e-07 3.07153C6.54393e-07 0.710585 2.54296 -0.765005 4.57732 0.41547L35.4742 18.3439Z" fill="currentColor" />
    </svg>
</button>
